import useSettings from "features/settings/useSettings";
import { useWebSocket } from "features/websoket/WebSocketProvider";
import { size } from "lodash";
import moment, { Moment } from "moment";
import { useEffect, useRef, useState } from "react";
import { HostItem, getHostData } from "./hostApi";

export default function useHostList() {
  const _storageStartDate = sessionStorage.getItem(`startDate`);
  const _storageEndDate = sessionStorage.getItem(`endDate`);
  const [range, setRange] = useState<
    { start?: Moment; end?: Moment } | undefined
  >({
    start: !!_storageStartDate
      ? moment(_storageStartDate).startOf("day")
      : moment().startOf("day"),
    end: !!_storageEndDate
      ? moment(_storageEndDate).endOf("day")
      : moment().endOf("day"),
  });

  const [settings, setSettings] = useSettings({ key: "host" });
  const loaded = useRef(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [hostData, setHostData] = useState<HostItem[]>([]);
  const { subscribe, unsubscribe } = useWebSocket();

  const handleFilter = async (
    startDate: string | undefined,
    endDate: string | undefined,
    boatIds: number[] | null,
    programIds: number[] | null,
    silent?: boolean
  ) => {
    if (!silent) {
      setLoading(true);
    }
    if (startDate) {
      sessionStorage.setItem(`startDate`, startDate);
    } else {
      sessionStorage.removeItem(`startDate`);
    }
    if (endDate) {
      sessionStorage.setItem(`endDate`, endDate);
    } else {
      sessionStorage.removeItem(`endDate`);
    }
    const { success, data } = await getHostData(
      startDate,
      endDate,
      boatIds,
      programIds
    );
    loaded.current = true;
    if (success) {
      setHostData(data || []);
    }
    if (!silent) {
      setLoading(false);
    }
  };
  function load(silent?: boolean) {
    return handleFilter(
      range?.start?.format("YYYY-MM-DD"),
      range?.end?.format("YYYY-MM-DD"),
      settings.boatIds,
      settings.programIds,
      silent
    );
  }
  const isEmpty = loaded.current && size(hostData) === 0;

  useEffect(() => {
    load();
  }, [range, settings.boatIds, settings.programIds]);

  const loader = useRef<(silent?: boolean) => void>();
  loader.current = load;
  useEffect(() => {
    if (range?.start && range?.end) {
      subscribe(
        "host",
        range?.start?.format("YYYY-MM-DD"),
        range?.end?.format("YYYY-MM-DD"),
        dates => {
          loader.current && loader.current(true);
        }
      );
    }
  }, [range]);

  useEffect(() => {
    return () => unsubscribe("host");
  }, []);

  return {
    hostData,
    loading,
    load,
    handleFilter,
    setRange,
    range,
    loaded,
    isEmpty,
    setSettings,
  };
}
